class QueryDetailModel {
  constructor(model) {
    this.model = model;
  }
  

  // 基本信息
  get title() {
    const suffix = this.model.type === QUERY_TYPE.CCTQ ? '答卷' : '测评报告';
    return `${placeholderText(this.model.title)}${suffix}`;
  }

  get name() {
    return placeholderText(this.model.trueName);
  }

  get  medicalRecordNumber(){
    return placeholderText(this.model.mzh)
  }

  get sex() {
    return placeholderText(findKey(GENDER_CODE, `${this.model.sex}`));
  }

  get age() {
    return placeholderText(this.model.age.toFixed(0));
  }

  get assessmentTime() {
    return placeholderText(this.model.assessmentTime);
  }

  get type() {
    return this.model.type;
  }

  // 评估结果
  get score() {
    //保留一位小数的问卷
    const reserveOneNumberQuery = [QUERY_TYPE.CNCQ, QUERY_TYPE.QSQ]
    const isReserveOneNumber = reserveOneNumberQuery.some(el => el === this.model.type)
    return placeholderText(
      this.model.total?.toFixed(isReserveOneNumber ? 1 : 0),
      "分"
    );
  }

  get result() {
    return placeholderText(this.model.result);
  }

  // 表格
  get tableData() {
    var data, rule;
    switch (this.model.type) {
      case QUERY_TYPE.CSHQ:
        data = this.model.selfContent.map((item) => {
          return {
            title: placeholderText(item.title),
            content: placeholderText(item.content),
            score: placeholderText(item.score?.toFixed(0)),
          };
        });
        rule = [
          { prop: "title", label: "题目", width: 453 },
          { prop: "content", label: "填写内容", width: 120 },
          { prop: "score", label: "得分", width: null },
        ];
        break;
      case QUERY_TYPE.CNCQ:
      case QUERY_TYPE.HAMD:
        data = this.model.selfContent.map((item) => {
          return {
            title: placeholderText(item.title),
            content: placeholderText(item.content),
            score: placeholderText(item.score?.toFixed(1)),
          };
        });
        rule = [
          { prop: "title", label: "题目", width: 453 },
          { prop: "content", label: "填写内容", width: 120 },
          { prop: "score", label: "得分", width: null },
        ];
        break;
      case QUERY_TYPE.BISQ:
      case QUERY_TYPE.DIET:
      case QUERY_TYPE.CCTQ:
      case QUERY_TYPE.PSQI:
      case QUERY_TYPE.AIS:
      case QUERY_TYPE.MOCA:
      case QUERY_TYPE.EQ_5D_5L:
      case QUERY_TYPE.RLSQ:
        data = this.model.selfContent.map((item) => {
          return {
            title: placeholderText(item.title),
            content: placeholderText(item.content),
          };
        });
        rule = [
          { prop: "title", label: "题目", width: 485 },
          { prop: "content", label: "填写内容", width: null },
        ];
        break;
      case QUERY_TYPE.STOP_Bang:
      case QUERY_TYPE.ESS:
      case QUERY_TYPE.Conners:
      case QUERY_TYPE.GAD:
      case QUERY_TYPE.PHQ:
      case QUERY_TYPE.ISI:
      case QUERY_TYPE.FSS:
      case QUERY_TYPE.MMSE:
      case QUERY_TYPE.GDS30:
      case QUERY_TYPE.SAS:
      case QUERY_TYPE.NO_SAS:
      case QUERY_TYPE.RSI:
      case QUERY_TYPE.RFS:
      case QUERY_TYPE.QSQ:
      case QUERY_TYPE.HADS:
      case QUERY_TYPE.CTRS:
      case QUERY_TYPE.BQ:
      case QUERY_TYPE.GHQ12:
      case QUERY_TYPE.RDQ:
      case QUERY_TYPE.GerdQ:
      case QUERY_TYPE.CHILD_SLEEP_HEALTH_SCREENING:

        data = this.model.selfContent.map((item) => {
          return {
            title: placeholderText(item.title),
            score: placeholderText(item.score?.toFixed(0)),
          };
        });
        rule = [
          { prop: "title", label: "题目", width: 562 },
          { prop: "score", label: "得分", width: null },
        ];
        break;
      case QUERY_TYPE.EQC:
        data = this.model.selfContent.map((item) => {
          return {
            type: placeholderText(item.depth),
            title: placeholderText(item.title),
            score: placeholderText(item.score?.toFixed(0)),
          };
        });
        rule = [
          { prop: "type", label: "分类", width: 82 },
          { prop: "title", label: "题目", width: 560 },
          { prop: "score", label: "得分", width: null },
        ];
        break;
      case QUERY_TYPE.PSQ:
      case QUERY_TYPE.OSA_18:
      case QUERY_TYPE.HAMA:
        data = this.model.selfContent.map((item) => {
          return {
            depth: placeholderText(item.depth),
            title: placeholderText(item.title),
            score: placeholderText(item.score?.toFixed(0)),
          };
        });
        rule = [
          { prop: "depth", label: "纬度", width: 112 },
          { prop: "title", label: "题目", width: 538 },
          { prop: "score", label: "得分", width: null },
        ];
        break;
      default:
        break;
    }
    return {
      type: this.type,
      data,
      rule,
    };
  }

  // 图表
  get chartData() {
    switch (this.model.type) {
      case QUERY_TYPE.PHQ:
      case QUERY_TYPE.GAD:
      case QUERY_TYPE.Conners:
      case QUERY_TYPE.ESS:
      case QUERY_TYPE.CNCQ:
        return {
          max: 3,
          interval: 1,
          chartArray: this.model.depthValue,
        };
      case QUERY_TYPE.PSQ:
        return {
          max: 9,
          interval: 3,
          chartArray: this.model.depthValue,
        };
      case QUERY_TYPE.OSA_18:
        return {
          max: 28,
          interval: 7,
          chartArray: this.model.depthValue,
        };
      case QUERY_TYPE.EQC:
        return {
          max: 88,
          interval: 22,
          chartArray: this.model.depthValue,
        };
      case QUERY_TYPE.STOP_Bang:
      case QUERY_TYPE.CHILD_SLEEP_HEALTH_SCREENING:
        return {
          max: 1,
          interval: 1,
          chartArray: this.model.depthValue,
        };
      case QUERY_TYPE.ISI:
        return {
          max: 4,
          interval: 1,
          chartArray: this.model.depthValue,
        };
      default:
        return undefined;
    }
  }

  // 指导意见
  get suggestion() {
    return placeholderText(this.model.measures);
  }
}

export { QueryDetailModel };
